import { api } from '@/lib/api';
import type {
  CompleteTrainingInput,
  TrainingAssignment,
  TrainingAssignmentDetail,
  TrainingAssignmentsResponse,
  TrainingDirectoryEmployee,
  TrainingFilters,
  TrainingProfile,
  TrainingProfileInput,
  TrainingQuizAttempt,
  TrainingSignature,
  TrainingSummary,
  TrainingSupervisorAlert,
} from '../types/training.types';

const BASE = '/v4/eqms-training';

export function getMyTrainingSummary(): Promise<TrainingSummary> {
  return api.get(`${BASE}/me/summary`);
}

export function getMyTrainingAssignments(filters: TrainingFilters): Promise<TrainingAssignmentsResponse> {
  return api.get(`${BASE}/me/assignments`, filters as unknown as Record<string, unknown>);
}

export function getTrainingAssignment(id: string): Promise<TrainingAssignmentDetail> {
  return api.get(`${BASE}/assignments/${id}`);
}

export function saveTrainingProgress(id: string): Promise<{ assignment: TrainingAssignment }> {
  return api.patch(`${BASE}/assignments/${id}/progress`, { readAttested: true });
}

export function submitTrainingQuiz(
  id: string,
  answers: Record<string, string>,
): Promise<{ attempt: TrainingQuizAttempt; assignment: TrainingAssignment }> {
  return api.post(`${BASE}/assignments/${id}/quiz-attempts`, { answers });
}

export function completeTraining(
  id: string,
  input: CompleteTrainingInput,
): Promise<{ assignment: TrainingAssignment; signature: TrainingSignature }> {
  return api.post(`${BASE}/assignments/${id}/complete`, input);
}

export function getTrainingCompliance(filters: TrainingFilters): Promise<TrainingAssignmentsResponse> {
  return api.get(`${BASE}/compliance`, filters as unknown as Record<string, unknown>);
}

export function getTrainingProfiles(): Promise<{ profiles: TrainingProfile[] }> {
  return api.get(`${BASE}/profiles`);
}

export function getTrainingDirectory(): Promise<{ employees: TrainingDirectoryEmployee[] }> {
  return api.get(`${BASE}/directory`);
}

export function createTrainingProfile(
  input: TrainingProfileInput,
): Promise<{ profile: TrainingProfile }> {
  return api.post(`${BASE}/profiles`, input);
}

export function updateTrainingProfile(
  id: string,
  input: TrainingProfileInput,
): Promise<{ profile: TrainingProfile }> {
  return api.put(`${BASE}/profiles/${id}`, input);
}

export function getTrainingSupervisorAlerts(): Promise<{ alerts: TrainingSupervisorAlert[] }> {
  return api.get(`${BASE}/me/alerts`);
}
